import { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';

import PropTypes from 'prop-types';
// material
import { alpha, styled } from '@mui/material/styles';
import {
    Box, Stack, Modal, AppBar, Toolbar, IconButton, Typography, Divider, TextField, Badge, Paper, Menu, Popper,
    ClickAwayListener,
} from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
// components
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
// icon
import { Icon } from '@iconify/react';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import { startOfMonth, endOfMonth, format } from 'date-fns';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { PickersDay } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { CalendarPicker } from '@mui/x-date-pickers/CalendarPicker';
import Iconify from '../../components/Iconify';
import Searchbar from './Searchbar';
import AccountPopover from './AccountPopover';
import LanguagePopover from './LanguagePopover';
import NotificationsPopover from './NotificationsPopover';
import AppCache from '../../services/AppCache';
import URLS from '../../services/urls.service';
import DashBoardMenuService from '../../services/dashBoardMenu.service';
// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 50;
// const APPBAR_MOBILE = 64;
// const APPBAR_DESKTOP = 92;
const APPBAR_DESKTOP = 50;
    
const RootStyle = styled(AppBar)(({ theme }) => ({
    boxShadow: 'none',
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
    // background: alpha(theme.palette.primary.light, 0.20),
    // background: alpha(theme.palette.cyan.dark, 0.5),
    // background: '#fbe9e7',
    background: '#FFFFFF',
    borderBottom: `1px solid #E5E7EB`
    // background: '#723D46',
    // backgroundColor: alpha(theme.palette.background.default, 0.72),

}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
    minHeight: APPBAR_MOBILE,
    [theme.breakpoints.up('sm')]: {
        minHeight: APPBAR_DESKTOP,
        padding: theme.spacing(0, 2),
    },
}));

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
    onOpenSidebar: PropTypes.func,
};
const style = {
    position: 'absolute',
    top: '50%',
    justifyContent: 'center',
    left: '50%',
    transform: 'translate(-50%, -50%)',

    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 10,
    p: 4,
};


export default function DashboardNavbar({ onOpenSidebar, openNav, dwidth }) {
    const location = useLocation();

    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();
    const [username, setDashboardusername] = useState([]);
    const [userId, setUserId] = useState([]);
    const [mark, setMark] = useState(false);
    const [isSaplUser, setIsSaplUser] = useState(false);
    const [date, setDate] = useState(null);
    const [currentMonth, setCurrentMonth] = useState(() => startOfMonth(new Date()));
    const [attendanceData, setAttendanceData] = useState([]);

    const [anchorEl, setAnchorEl] = useState(null);
    const openDateBox = Boolean(anchorEl);

    const handleDateClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleCloseDate = () => {
        setAnchorEl(null);

        const formattedDate = format(startOfMonth(new Date()), "dd-MMM-yyyy");
        fetchAttendanceReport(formattedDate);
    };

    // Modal
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handelCancel = () => {
        navigate('/login', { relpace: true });
    }
    const fetchAttendanceReport = (monthStartDate) => {
        const payload = {
            LoginUserId: CurrentLoggedInUser.ExecutiveId,
            Date: monthStartDate, // send start of month
            DisplayFor: 0,
            Output: 0
        };

        URLS.getAttendanceReport(payload)
            .then((response) => {
                if (response.status === 200) {
                    setAttendanceData(response.data);
                }
            })
            .catch(error => {
                console.log("Error", error);
            });
    };


    useEffect(() => {
        // if (isOpenSidebar) {
        //  onCloseSidebar();
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        setDashboardusername(CurrentLoggedInUser.ExecutiveName);
        setUserId(CurrentLoggedInUser.ExecutiveId);
        setIsSaplUser(CurrentLoggedInUser.IsSaplUser)
        const ContactId = CurrentLoggedInUser.ExecutiveId;
        URLS.getAttendance(ContactId)
            .then((response) => {
                console.log("response.status", response.data.status);
                if (response.data.status === true) {
                    setMark(true);
                } else {
                    setMark(false);
                }


            }).catch(error => {
                // On error
                console.log(" Error ");
            });

        fetchAttendanceReport(format(currentMonth, "dd-MMM-yyyy"));

        // console.log(" SetProjects", CurrentLoggedInUser.Menus);
    }, []);

    const handleMonthChange = (newMonth) => {
        const firstDay = startOfMonth(newMonth);
        setCurrentMonth(firstDay);
        fetchAttendanceReport(format(firstDay, "dd-MMM-yyyy"));
    };

    const onChangeMark = () => {
        console.log("hii")
        const PayloadAttendance = {
            'userDetails': [
                {
                    ContactId: userId, Lat: '0', Long: '0'

                }
            ]
        };
        console.log("PayloadAttendance", PayloadAttendance);
        URLS.postaddAttendance(PayloadAttendance)
            .then((response) => {
                console.log("ssds");
                setMark(true);
            }).catch(error => {
                // On error
                console.log(" Error ");
            });

    }

    const navigate = useNavigate();
    const handleLogOut = () => {

        navigate('/login', { relpace: true });

    };

    const acknowledgeList = [
        {
            id: 1,
            type: "pending",
            time: "5 min ago",
            issueIds: ["515089", "515090"],
        },
        {
            id: 2,
            type: "allocated",
            time: "1 day ago",
            issueIds: ["515089"],
        },
    ]

    const [notificationAnchor, setNotificationAnchor] = useState(null)

    const openAcknowledgeList = Boolean(notificationAnchor)

    const handleAcknowledgeClick = (event) => {
        setNotificationAnchor(event.currentTarget)
    }

    const handleCloseAcknowledge = () => {
        setNotificationAnchor(null)
    }

    const [acknowledgeModal, setAcknowledgeModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const handleAcknowledgeOpenModal = (item) => {
        setSelectedItem(item); // store the clicked item
        setAcknowledgeModal(true);
    };
    return (
        <RootStyle sx={{ width: { md: `calc(100% - ${dwidth}px)` } }}>
            <ToolbarStyle>
                {/* {<IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary', display: { lg: 'none' } }}> */}
                {!openNav && (<IconButton onClick={onOpenSidebar} sx={{ color: '#4e342e' }}>
                    <Iconify icon="bx:menu" />
                </IconButton>)}

                {!openNav && (
                    <Box component="img" src="/static/illustrations/TikeTicLOGO.png" sx={{
                        width: 95, height: 46
                    }} />
                )}
                <Box sx={{ flexGrow: 1 }} />
                {/* {isSaplUser && */}
                {/*    ( */}
                {/*        <Box sx={{ position: "relative", display: "inline-block", mr: 2, ml: 1 }}> */}

                {/*            <Tooltip title="Notification"> */}
                {/*                <Badge */}
                {/*                    badgeContent={2} */}
                {/*                    overlap="circular" */}
                {/*                    sx={{ */}
                {/*                        "& .MuiBadge-badge": { */}
                {/*                            width: 20, */}
                {/*                            height: 19, */}
                {/*                            minWidth: 20, */}
                {/*                            backgroundColor: "#E7000B", */}
                {/*                            color: "#FFFFFF", */}
                {/*                            boxShadow: "0px 0px 1px 0px #00000040", */}
                {/*                            fontSize: 12, */}
                {/*                            fontWeight: 500, */}
                {/*                            borderRadius: '6px', */}
                {/*                            marginRight: '5px' */}
                {/*                        }, */}
                {/*                    }} */}
                {/*                > */}
                {/*                    <NotificationsOutlinedIcon */}
                {/*                        sx={{ color: "#374151", mr: 1, width: 24, height: 24, cursor: "pointer" }} */}
                {/*                        onClick={handleAcknowledgeClick} */}
                {/*                    /> */}
                {/*                </Badge> */}

                {/*            </Tooltip> */}
                {/*            */}{/* Notification Popover */}
                {/*            <Menu */}
                {/*                anchorEl={notificationAnchor} */}
                {/*                open={openAcknowledgeList} */}
                {/*                onClose={handleCloseAcknowledge} */}
                {/*                MenuListProps={{ disablePadding: true }} */}
                {/*                anchorOrigin={{ */}
                {/*                    vertical: "bottom", */}
                {/*                    horizontal: "center", */}
                {/*                }} */}
                {/*                transformOrigin={{ */}
                {/*                    vertical: "top", */}
                {/*                    horizontal: "center", */}
                {/*                }} */}
                {/*                PaperProps={{ */}
                {/*                    sx: { */}
                {/*                        mt: "10px", */}
                {/*                        width: 308, */}
                {/*                        borderRadius: 1, */}
                {/*                        p: 0, */}
                {/*                        boxShadow: ' 0px 0px 4px 0px #00000040' */}

                {/*                    }, */}
                {/*                }} */}
                {/*            > */}
                {/*                */}{/* Sticky Header */}
                {/*                <Box */}
                {/*                    sx={{ */}
                {/*                        position: 'sticky', */}
                {/*                        top: 0, */}
                {/*                        zIndex: 1, */}
                {/*                        backgroundColor: '#fff', */}
                {/*                        borderBottom: '1px solid #D1D5DB', */}
                {/*                        display: 'flex', */}
                {/*                        justifyContent: 'space-between', */}
                {/*                        alignItems: 'center', */}
                {/*                        px: 2, */}

                {/*                    }} */}
                {/*                > */}
                {/*                    <Typography variant="h6" fontWeight="600"> */}
                {/*                        Notification */}
                {/*                    </Typography> */}
                {/*                    <IconButton onClick={handleCloseAcknowledge} sx={{ color: "#626165" }}> */}
                {/*                        <CloseIcon /> */}
                {/*                    </IconButton> */}
                {/*                </Box> */}

                {/*                {acknowledgeList.map((item, index) => ( */}
                {/*                    <Box */}
                {/*                        key={item.id} */}
                {/*                        sx={{ */}
                {/*                            px: 2, */}
                {/*                            py: 1, */}
                {/*                            cursor: "pointer", */}

                {/*                            border: */}
                {/*                                index !== acknowledgeList.length - 1 */}
                {/*                                    ? "1px solid #F1F1F1" */}
                {/*                                    : "none", */}

                {/*                        }} */}
                {/*                        onClick={handleCloseAcknowledge} */}
                {/*                    > */}
                {/*                        */}{/* HEADER ROW */}
                {/*                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}> */}
                {/*                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}> */}
                {/*                                <Box */}
                {/*                                    sx={{ */}
                {/*                                        width: 14, */}
                {/*                                        height: 14, */}
                {/*                                        borderRadius: "50%", */}
                {/*                                        display: "flex", */}
                {/*                                        alignItems: "center", */}
                {/*                                        justifyContent: "center", */}
                {/*                                        backgroundColor: item.type === "pending" ? "#FFEDEE" : "#EEF4FF", */}
                {/*                                        mb: 1 */}
                {/*                                    }} */}
                {/*                                > */}
                {/*                                    {item.type === "pending" ? */}
                {/*                                        <ErrorOutlineOutlinedIcon sx={{ color: '#E7000B', width: 10, height: 10, }} /> */}
                {/*                                        : <AssignmentTurnedInOutlinedIcon sx={{ color: '#3C97FF', width: 10, height: 10, }} /> */}
                {/*                                    } */}
                {/*                                </Box> */}
                {/*                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}> */}

                {/*                                    <Typography fontSize={12} fontWeight={500}> */}
                {/*                                        {item.type === "pending" */}
                {/*                                            ? "Pending Acknowledgements" */}
                {/*                                            : "New Allocated issue"} */}
                {/*                                    </Typography> */}
                {/*                                </Box> */}

                {/*                            </Box> */}


                {/*                        </Box> */}

                {/*                        */}{/* DESCRIPTION */}
                {/*                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}> */}

                {/*                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, flex: 1 }}> */}
                {/*                                <Typography fontSize={11} color="#848FA0"> */}
                {/*                                    {item.type === "pending" */}
                {/*                                        ? `You have ${item.issueIds.length} issues pending on your acknowledge list. Please acknowledge this issues to set deadlines.` */}
                {/*                                        : `You have ${item.issueIds.length} issue allocated by "Rakesh Shetty".`} */}
                {/*                                </Typography> */}
                {/*                            </Box> */}
                {/*                            <Typography */}
                {/*                                fontSize={11} */}
                {/*                                color="#848FA0" */}
                {/*                                sx={{ whiteSpace: "nowrap", flexShrink: 0 }} */}
                {/*                            > */}
                {/*                                {item.time} */}
                {/*                            </Typography> */}
                {/*                        </Box> */}

                {/*                        */}{/* ISSUE IDS */}
                {/*                        <Typography fontSize={10} fontWeight={500} color='#666060'> */}
                {/*                            Issue IDs: */}
                {/*                        </Typography> */}

                {/*                        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 0.5 }}> */}
                {/*                            {item.issueIds.map((id) => ( */}
                {/*                                <Box */}
                {/*                                    key={id} */}
                {/*                                    sx={{ */}
                {/*                                        px: 1.5, */}
                {/*                                        py: 0.5, */}
                {/*                                        borderRadius: "6px", */}
                {/*                                        fontSize: "10px", */}
                {/*                                        fontWeight: 500, */}
                {/*                                        backgroundColor: item.type === "pending" ? "#FFF6F6" : "#F6F9FF", */}
                {/*                                        color: item.type === "pending" ? "#E7000B" : "#0062FF", */}
                {/*                                    }} */}
                {/*                                > */}
                {/*                                    {id} */}
                {/*                                </Box> */}
                {/*                            ))} */}
                {/*                        </Box> */}
                {/*                    </Box> */}
                {/*                ))} */}

                {/*            </Menu> */}

                {/*        </Box> */}
                {/*    )} */}

                {isSaplUser &&
                    (
                        <Box sx={{ position: "relative", display: "inline-block", }}>

                            {/* Calendar Icon with Badge */}
                            <Tooltip title="Work From Office Days">
                                <Badge
                                    badgeContent={attendanceData.length}
                                    overlap="circular"
                                    sx={{
                                        "& .MuiBadge-badge": {
                                            width: 20,
                                            height: 19,
                                            minWidth: 20,
                                            backgroundColor: "#78C043",
                                            color: "#FFFFFF",
                                            boxShadow: "0px 0px 1px 0px #00000040",
                                            fontSize: 12,
                                            fontWeight: 500,
                                            borderRadius: '6px',
                                            marginRight: '2px'
                                        },
                                    }}
                                >
                                    <CalendarMonthOutlinedIcon
                                        sx={{ color: "#374151", mr: 1, width: 24, height: 24, cursor: "pointer" }}
                                        onClick={handleDateClick}
                                    />
                                </Badge>
                            </Tooltip>

                            {/* Calendar Popover */}
                            {openDateBox && (
                                <Menu
                                    anchorEl={anchorEl}
                                    open={openDateBox}
                                    onClose={handleCloseDate}
                                    MenuListProps={{ disablePadding: true }}
                                    anchorOrigin={{
                                        vertical: "bottom",
                                        horizontal: "center",
                                    }}
                                    transformOrigin={{
                                        vertical: "top",
                                        horizontal: "center",
                                    }}
                                    PaperProps={{
                                        sx: {
                                            p: 1,
                                            borderRadius: '10px',
                                            mt: "10px",
                                            boxShadow: "0px 0px 4px 0px #00000040",

                                        }
                                    }}
                                >
                                    {/* HEADER */}
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: 1 }}>
                                        <Typography sx={{ fontWeight: 500, fontSize: "12px", color: "#121212" }}>
                                            Total Work From Office
                                        </Typography>
                                        <Box sx={{
                                            backgroundColor: "#78C043",
                                            color: "#fff",
                                            px: 1.5, py: 0.5, borderRadius: "12px",
                                            fontSize: "12px", fontWeight: 500
                                        }}>
                                            {attendanceData.length} {attendanceData.length === 1 ? "Day" : "Days"}
                                        </Box>
                                    </Box>

                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <Box sx={{ height: 285, border: "1px solid #F0F0F0", overflow: "hidden" }}>
                                            <Box
                                                sx={{
                                                    transform: "scale(0.90)",
                                                    transformOrigin: "top left",
                                                    width: 285
                                                }}
                                            >
                                                <CalendarPicker
                                                    date={date}
                                                    onChange={(newDate) => setDate(newDate)}
                                                    disableFuture
                                                    onMonthChange={handleMonthChange}
                                                    renderDay={(day, _selectedDates, pickersDayProps) => {
                                                        const punchDates = attendanceData.map(d => {
                                                            const [year, monthStr, dayStr] = d.PunchDate.split("-");
                                                            const monthMap = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11 };
                                                            return new Date(year, monthMap[monthStr], parseInt(dayStr, 10));
                                                        });

                                                        const isPunchDay = punchDates.some(d =>
                                                            d.getFullYear() === day.getFullYear() &&
                                                            d.getMonth() === day.getMonth() &&
                                                            d.getDate() === day.getDate()
                                                        );

                                                        const today = new Date();
                                                        const isToday =
                                                            today.getFullYear() === day.getFullYear() &&
                                                            today.getMonth() === day.getMonth() &&
                                                            today.getDate() === day.getDate();

                                                        return (
                                                            <PickersDay
                                                                {...pickersDayProps}
                                                                sx={{
                                                                    pointerEvents: "none",
                                                                    borderRadius: 1,
                                                                    ...(isPunchDay && { bgcolor: "#E8FEE1", color: "#48BE1D" }),
                                                                    ...(isToday && !pickersDayProps.selected && { border: "1px solid #00A63E !important" }),
                                                                }}
                                                            />
                                                        );
                                                    }}

                                                />
                                            </Box>
                                        </Box>
                                    </LocalizationProvider>

                                    {/* Footer */}
                                    <Box sx={{ p: 1, display: "flex", justifyContent: "center", alignItems: "center", gap: 5 }}>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                            <Box sx={{ width: 20, height: 16, bgcolor: "#E8FEE1", borderRadius: "5px" }} />
                                            <Typography sx={{ fontWeight: 500, fontSize: "12px" }}>Work From Office</Typography>
                                        </Box>

                                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                            <Box sx={{ width: 20, height: 16, border: "1px solid #00A63E", borderRadius: "5px" }} />
                                            <Typography sx={{ fontWeight: 500, fontSize: "12px" }}>Today</Typography>
                                        </Box>
                                    </Box>
                                </Menu>

                            )}
                        </Box>
                    )}


                <Divider
                    orientation="vertical"
                    flexItem
                    sx={{ mx: 2, color: '#E5E7EB' }}  // space around divider
                />
                <AccountPopover />

                <Typography variant="subtitle1" sx={{ color: '#000000', ml: 1, mr: 2 }}>
                    {username}
                </Typography>
                <Tooltip title="Log out">
                    <IconButton onClick={handleOpen}
                        sx={{
                            color: '#E7000B',
                            // ":hover": {
                            //    cursor: "pointer",
                            //    color: "#FB0000",

                            // },
                        }}
                    >
                        <Icon icon="material-symbols:power-settings-circle-outline" width={24} height={24} />
                    </IconButton>
                </Tooltip>
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" sx={{ mb: 2, textAlign: 'center' }} gutterBottom>
                            Confirm Logout?
                        </Typography>
                        <Stack direction="row" justifyContent="center" alignItems="center" spacing={3}>

                            <Button
                                onClick={handelCancel}
                                size="small"
                                variant="contained"
                            >
                                Yes
                            </Button>
                            <Button
                                onClick={handleClose}
                                size="small"
                                variant="contained"
                            >
                                No
                            </Button>
                        </Stack>
                    </Box>
                </Modal>
                {isSaplUser && (
                    mark === true ?
                        <Tooltip title="I am present">
                            <IconButton onClick={onChangeMark} value={mark}
                                /* 64dd17 */
                                sx={{ color: '#64dd17' }}

                            >

                                <Icon icon="ic:twotone-fingerprint" width={24} height={24} />
                            </IconButton></Tooltip> :

                        <IconButton onClick={onChangeMark} value={mark}
                            sx={{
                                // color: '#B50000',
                                color: '#E7000B',
                                ":hover": {
                                    cursor: "pointer",
                                    color: "#FB0000",

                                },
                            }}>

                            <Icon icon="ic:twotone-fingerprint" width={24} height={24} />
                        </IconButton>
                )}
            </ToolbarStyle>
        </RootStyle>
    );
}
